import { type BusinessUserWithSeats } from "lens-platform-sdk/dist/cjs/BusinessService";

export function isOfflineDeletedUserAccount(user: BusinessUserWithSeats): boolean {
  return user.id === "" && user.seats[0]?.offline === true;
}
